import { useTranslation } from 'react-i18next';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { Section } from '@/common/components/Section/Section';
import { ROUTES } from '@/common/constants/routes';
import { HomeInsuranceCard } from '@/common/containers/Dashboard/Home/HomeInsuranceCard/HomeInsuranceCard';
import { HomeLayout } from '@/common/containers/Dashboard/Home/HomeLayout/HomeLayout';
import { PocketCardsGrid } from '@/common/containers/Dashboard/Home/PocketCardsGrid/PocketCardsGrid';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetCompensationSummary } from '@/common/integrations/menhir/employee/compensation/compensation.hooks';
import {
  useGetInsurancePolicies,
  useInsuranceOptInEligibility,
} from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { ESBenefitsCardPocket } from './ESBenefitsCardPocket/ESBenefitsCardPocket';
import { ESBenefitsSpendingCard } from './ESBenefitsSpendingCard/ESBenefitsSpendingCard';
import { ESGettingStartedCard } from './ESGettingStartedCard/ESGettingStartedCard';
import { ESHealthInsuranceAddCard } from './ESHealthInsuranceAddCard/ESHealthInsuranceAddCard';
import { useGetESHomeSecondaryActions } from './ESHomePage.utils';

export function ESWalletHomePage() {
  const { t } = useTranslation();
  const {
    features: { ff_es_health_insurance_opt_in, ff_sea_activity },
  } = useFeatures();
  const {
    summary: compensationSummary,
    isInitialLoading: loadingCompensationSummary,
  } = useGetCompensationSummary();
  const { policies, isInitialLoading: loadingInsurance } =
    useGetInsurancePolicies();
  const { eligible } = useInsuranceOptInEligibility({
    enabled: Boolean(ff_es_health_insurance_opt_in),
  });

  const secondaryActions = useGetESHomeSecondaryActions();

  if (loadingCompensationSummary || loadingInsurance) {
    return <LoadingPlaceholder />;
  }

  const healthPolicy = policies?.find(
    (policy) => policy.product.plan.type === 'health'
  );

  return (
    <HomeLayout
      pocketCardsSlot={
        <>
          <PocketCardsGrid>
            <ESBenefitsCardPocket summary={compensationSummary} />
          </PocketCardsGrid>
          {(compensationSummary?.benefits.length ?? 0) > 0 && (
            <Section title={t('dashboard.home.es.wallet.spendings_limits')}>
              <PocketCardsGrid>
                {compensationSummary?.benefits.map((benefit, idx) => (
                  <ESBenefitsSpendingCard
                    key={idx}
                    slug={benefit.slug}
                    balance={benefit.balance}
                  />
                ))}
              </PocketCardsGrid>
            </Section>
          )}
        </>
      }
      secondaryActionsSlot={
        <>
          <ESGettingStartedCard />
          {secondaryActions}
        </>
      }
      bottomSlot={
        <>
          {healthPolicy && <HomeInsuranceCard policy={healthPolicy} />}
          {eligible && <ESHealthInsuranceAddCard />}
        </>
      }
      activityRoute={ff_sea_activity ? ROUTES.HOME_ACTIVITY : undefined}
    />
  );
}
